import React from "react";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { CMS_DESTINATION_LABEL } from "../utils/constants";

class SentToForgeToast extends React.Component {
  render() {
    const { link } = this.props;
    return (
      <div>
        Sent to Forge!
        <div>
          <a
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}
          >
            {`View in ${CMS_DESTINATION_LABEL[link.destination]}`}
            <OpenInNewIcon style={{ fontSize: "1rem" }} />
          </a>
        </div>
      </div>
    );
  }
}

export default SentToForgeToast;



// WEBPACK FOOTER //
// ./src/components/SentToForgeToast.js